const WEBHOOK_ASSISTENTE_TEXTO = 'https://webhook.pasiai.com/webhook/AssistenteTexto'

const PROMPT_SUGERIR_TITULO_NOTIFICACAO =  'Crie um título curto, chamativo e envolvente para a notificação abaixo, com base na mensagem fornecida. O título deve chamar a atenção do leitor, usar emojis relevantes no início ou ao longo do texto e resumir o assunto principal em no máximo 5 palavras. Não termine o título com ponto final. Mensagem da notificação: '

const PROMPT_MELHORAR_MENSAGEM_NOTIFICACAO =  'Melhore a mensagem da notificação abaixo, tornando o texto mais claro, direto e fácil de ler, com tom informal e amigável. A mensagem deve ter no máximo 200 caracteres. Não use emojis. Não use cumprimentos formais como "Prezado", "Prezada", "Meu caro", "Minha cara" ou similares. Corrija problemas de escrita, organize as informações de forma coerente e mantenha o significado original. Retorne apenas a mensagem melhorada em texto simples, sem emojis, respeitando o limite de 200 caracteres. Mensagem da notificação: '

type WebhookTemplateResponse = {
  responses?: Array<{ output?: string }>
}

export function extractAssistenteTextoOutput(payload: unknown): string | null {
  if (!Array.isArray(payload)) return null
  for (const item of payload) {
    const responses = (item as WebhookTemplateResponse)?.responses
    if (!Array.isArray(responses)) continue
    for (const r of responses) {
      if (typeof r?.output === 'string' && r.output.trim()) {
        return r.output.trim()
      }
    }
  }
  return null
}

async function fetchAssistenteTexto(texto: string): Promise<string> {
  const params = new URLSearchParams({ texto })
  const controller = new AbortController()
  const timeoutId = setTimeout(() => controller.abort(), 120000)

  try {
    const response = await fetch(`${WEBHOOK_ASSISTENTE_TEXTO}?${params.toString()}`, {
      method: 'GET',
      signal: controller.signal,
    })

    if (!response.ok) {
      let detail = `Erro HTTP ${response.status}`
      try {
        const errJson = await response.json()
        if (errJson?.message) detail = String(errJson.message)
      } catch {
        const errText = await response.text().catch(() => '')
        if (errText) detail = errText
      }
      throw new Error(detail)
    }

    const data: unknown = await response.json()
    const output = extractAssistenteTextoOutput(data)
    if (!output) {
      throw new Error('Resposta recebida, mas sem campo output nas responses.')
    }
    return output
  } catch (e: unknown) {
    if (e instanceof Error && e.name === 'AbortError') {
      throw new Error('Tempo esgotado (120s). Tente novamente.')
    }
    throw e
  } finally {
    clearTimeout(timeoutId)
  }
}

export async function sugerirTituloNotificacaoPelaMensagem(mensagem: string): Promise<string> {  const texto = `${PROMPT_SUGERIR_TITULO_NOTIFICACAO}${mensagem.trim()}`
  const titulo = await fetchAssistenteTexto(texto)
  return titulo.replace(/\.+$/, '').trim()
}

const MENSAGEM_NOTIFICACAO_MAX_LENGTH = 200
export async function melhorarMensagemNotificacao(mensagem: string): Promise<string> {
  const texto = `${PROMPT_MELHORAR_MENSAGEM_NOTIFICACAO}${mensagem.trim()}`
  const melhorada = await fetchAssistenteTexto(texto)
  return melhorada.slice(0, MENSAGEM_NOTIFICACAO_MAX_LENGTH).trim()
}
